import { receiverImgName } from 'shared/receivers/receivers-helpers';


const checkboxWidth = 95;
// const lastSentWidth = '170px';

const colWidth = `calc(50% - ${checkboxWidth / 2}px)`;

export const columns: any = [
  {
    title: 'select-all-btn',
    width: `${checkboxWidth}px`,
    active: false,
    col: 'select-btn',
  },
  {
    title: 'Available receivers',
    width: colWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'name',
    active: false,
    col: 'name',
    type: 'html',
    handleClick: true,
    truncate: true,
    ghostValue: (row: any) => {
      return row.name;
    },
    data: receiverImgName,
  },
  {
    title: 'Notes',
    width: colWidth,
    sortable: true,
    sort: 'desc',
    sortName: 'note',
    active: false,
    col: 'note',
    truncate: true,
  },
  // {
  //   title: 'Last sent',
  //   width: lastSentWidth,
  //   sortable: true,
  //   sort: 'desc',
  //   sortName: 'last_sent',
  //   active: false,
  //   col: 'last_sent',
  //   truncate: true,
  // },
];
